import { render, staticRenderFns } from "./TransferChildVue.vue?vue&type=template&id=010fef52&scoped=true&"
import script from "./TransferChildVue.vue?vue&type=script&lang=js&"
export * from "./TransferChildVue.vue?vue&type=script&lang=js&"
import style0 from "./TransferChildVue.vue?vue&type=style&index=0&id=010fef52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010fef52",
  null
  
)

export default component.exports